import React, {useEffect, useState} from "react";
import { BrowserRouter, Routes, Route } from "react-router";

import FAQ from './components/faq/faq';
import Header from './components/header/header';
import Index from './components/index/index';
import Races from './components/races/races';
import Account from "./components/account/account";

import './app.css';
import { LoginInfo } from "./types/apiResponses";
import { useAtom } from "jotai";
import { updateUserAtom } from "./state/userAtoms";

const App = () => {
	const [lastWeekRace, setLastWeekRace] = useState(null);
	const [nextWeekRace, setNextWeekRace] = useState(null);
	const [, updateUser] = useAtom(updateUserAtom)

	useEffect(() => {
		const emptyUser = {
			isLoaded: true as const,
			name: '',
			nickname: undefined as string | undefined,
			roles: [] as string[],
		};

		fetch('/a/user', { credentials: 'same-origin' })
			.then(async res => {
				if (!res.ok) {
					updateUser(emptyUser);
					return;
				}
				const data = (await res.json()) as LoginInfo;

				if (!data?.name) {
					updateUser(emptyUser);
				} else {
					updateUser({
						isLoaded: true,
						name: data.name,
						nickname: data.nickname,
						roles: data.roles ?? [],
					});
				}
			})
			.catch(() => {
				updateUser(emptyUser);
			});
	}, [updateUser]);
	
	return <BrowserRouter>
		<Header />
			<div className='mainContainer'>
				<Routes>
					<Route index element={<Index lastRaceInfo={lastWeekRace} nextRaceInfo={nextWeekRace} />} />
					<Route 
						path='faq'
						element={<FAQ />}
					/>
					<Route 
						path='races/*'
						element={<Races />}
					/>
					<Route
						path="account/*"
						element={<Account />}
					/>
				</Routes>
			</div>
	</BrowserRouter>
}

export default App;